import { Menu } from '@mui/icons-material';
import { Badge, Box, IconButton, Theme, Typography, useMediaQuery, useTheme } from '@mui/material';
import * as React from 'react';
import { useNavigate, useParams } from 'react-router';
import MobileAvatar from '../Shared/MobileAvatar';
import { useTranslation } from 'react-i18next';
import { MeEmployeeResponse } from '../../../ApiOld/Api/ApiServerVov';

export interface IMobileAppMenuProps {
    label: string;
    domainString?: string;
    employeeInfo: MeEmployeeResponse;
    logout: () => void;
    moduleButton: JSX.Element | null;
    moduleSecondButton: JSX.Element | null;
    unreadMessages: number;
}

export default function MobileAppMenu(props: IMobileAppMenuProps) {
    const theme = useTheme();
    const params = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [avatarOpen, setAvatarOpen] = React.useState(false);
    const biggerThanXs = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));
    return (
        <Box height="48px" sx={{ position: 'relative', top: 0, width: '100%', display: 'flex' }}> { /* Tenhle box je tu proto, že box pod ním má position fixed a tím pádem nezabírá místo na obrazovce */}
            <Box
                height="48px"
                bgcolor={theme.palette.primary.main}
                sx={{
                    position: 'fixed',
                    top: 0,
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    zIndex: 1000,
                    backgroundColor: '#ffc600',
                }}
            >
                {!props.moduleButton && (
                    <IconButton
                        onClick={() => {
                            if (props.domainString)
                                navigate('/' + params['lang'] + '/' + props.domainString + '/employee/menu');
                            else navigate('/' + params['lang'] + '/' + params['domain'] + '/employee/menu');
                        }}
                        sx={{ minWidth: '48px', height: '48px', padding: 0, color: '#101920' }}
                    >
                        <Badge
                            badgeContent={props.unreadMessages}
                            sx={{
                                '& .MuiBadge-badge': {
                                    background: '#404040',
                                    color: 'white',
                                    fontSize: 10,
                                    fontWeight: 'bold',
                                    height: 16,
                                    width: 16,
                                    borderRadius: '50%',
                                    transform: 'scale(1) translate(50%, -50%)',
                                },
                            }}
                        >
                            <Menu sx={{ color: 'black' }} />
                        </Badge>
                    </IconButton>
                )}
                {props.moduleButton && (biggerThanXs || (!biggerThanXs && !avatarOpen)) && <Box>{props.moduleButton}</Box>}
                <Typography
                    onDoubleClick={() => {
                        // @ts-ignore
                        if (window.ReactNativeWebView)
                            // @ts-ignore
                            window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'clear-cache' }))
                    }}
                    sx={{
                        position: 'absolute',
                        left: props.moduleButton ? 'calc(48px + 1rem)' : '48px',
                        right: '48px',
                        lineHeight: '20px',
                        fontSize: 20,
                        color: '#101920',
                        fontWeight: 'bold',
                        whiteSpace: 'normal',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        textAlign: 'center',
                        maxHeight: '48px', // Ensure text does not exceed 48px height
                        display: '-webkit-box',
                        WebkitLineClamp: 2, // Limit to 2 lines
                        WebkitBoxOrient: 'vertical',
                    }}
                >
                    {avatarOpen && !biggerThanXs ? '' : t(props.label)}
                </Typography>

                {!props.moduleSecondButton && (
                    <MobileAvatar
                        initials={props.employeeInfo.initials}
                        fullName={props.employeeInfo.fullName}
                        arrivalNotifications={props.employeeInfo.workTimeNotifyFrom}
                        departureNotifications={props.employeeInfo.workTimeNotifyTo}
                        handleLogout={props.logout}
                        onChange={(e) => setAvatarOpen(!!e)}
                    />
                )}
                {props.moduleSecondButton && <Box>{props.moduleSecondButton}</Box>}
            </Box>
        </Box>
    );
}
